import * as ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import { HMO, Memberships, Services } from "../../../fakeDb";
import { Cloudinary, mobile } from "../..";

const border = {
  top: { style: "thin" },
  left: { style: "thin" },
  right: { style: "thin" },
  bottom: { style: "thin" },
};
const getBanner = async () => {
  try {
    const { branch } = JSON.parse(
      localStorage.getItem("activePlatform") || "{}"
    );
    const { companyId = {}, name = "" } = branch || {};
    const path = `${Cloudinary.getEndpoint()}/companies/${
      companyId?.name
    }/${name}/banner.png`;
    const response = await fetch(path);
    if (!response.ok) {
      console.error(
        "Failed to fetch image:",
        response.status,
        response.statusText
      );
      return null;
    }

    const blob = await response.blob();
    const base64 = await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // returns full base64 string
      reader.onerror = reject;
      reader.readAsDataURL(blob); // converts to data:image/png;base64,...
    });

    return base64;
  } catch (error) {
    console.error("Error in getBanner:", error);
    return null;
  }
};

const alphabets = "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  getAlpha = (pos) => {
    let result = "";
    const base = 26;

    while (pos >= 0) {
      result = alphabets[pos % base] + result;
      pos = Math.floor(pos / base) - 1;

      if (pos < 0) {
        break;
      }
    }

    return result;
  };

const handleHeader = (worksheet, form) => {
  const { menuType, hmo } = form;
  const generateStaticCell = (mergeCell, label, value, position = "left") => {
    worksheet.mergeCells(mergeCell);
    const startCell = mergeCell.split(":")[0];
    const data = worksheet.getCell(startCell);

    // Set rich text value
    data.value = {
      richText: [
        { text: `${label}: `, font: { bold: true, size: 13 } },
        { text: value, font: { bold: false, size: 13 } },
      ],
    };

    data.border = border;
    data.alignment = { horizontal: position, vertical: "middle" };
  };

  if (menuType === "hmo") {
    const { branch = {} } = JSON.parse(localStorage.getItem("activePlatform"));
    const { companyId = {} } = branch;
    const { hmo: h } = companyId;
    const { cp } = h.find(({ code }) => code === hmo) || {};
    const { phone } = cp;
    generateStaticCell("A5:F5", "Name", HMO.getName(hmo));
    generateStaticCell("G5:L5", "Contact Number.", mobile(phone));
  }
  if (menuType === "mbs") {
    const { insource } = form;
    const { name = "", displayname = "", membership } = insource;
    console.log("insource", insource);
    generateStaticCell("A5:G5", "Name", name || displayname);
    generateStaticCell(
      "H5:N5",
      "Membership",
      Memberships.getMembership(membership),
      "right"
    );
  }

  if (menuType === "ctr") {
    const { insource } = form;
    const { name = "", displayname = "", contract } = insource;
    const contracts = { sbc: "Subcontract", ssc: "Special Subcontract" };
    generateStaticCell("A5:F5", "Name", name || displayname);
    generateStaticCell("G5:L5", "Contract", contracts[contract], "right");
  }
};

const set = {
  banner: async ({ worksheet, workbook, form }) => {
    // Load image from public folder
    try {
      const { priceCategories = [], menuType = "" } = form;
      const isInhouse = menuType === "inhouse";
      const isMembership = menuType === "mbs";

      const image = await getBanner();
      const base64 = image.replace(/^data:image\/\w+;base64,/, "");

      const imageId = workbook.addImage({
        base64,
        extension: "png",
      });

      const additionalCol = isInhouse
        ? priceCategories.length * 2
        : isMembership
        ? 4
        : 2;

      worksheet.addImage(imageId, {
        tl: { col: 0, row: 0.05 }, // A4 = col 0, row 3 (zero-based)
        br: { col: 10 + additionalCol, row: 4 },
      });
    } catch (err) {
      console.error("Failed to add image to Excel:", err);
    }
  },
  header: ({ worksheet, form }) => {
    const { priceCategories = [], menuType } = form;
    const isInhouse = menuType === "inhouse";
    const isMembership = menuType === "mbs";

    const baseColumns = 10; // A to J → index 0 to 9
    const extraColumns = priceCategories.length * 2;
    const endColIndex = baseColumns + extraColumns - 1; // zero-based index
    const endColumnLetter = getAlpha(endColIndex); // e.g., "P"

    if (!isInhouse) handleHeader(worksheet, form);

    const column = isInhouse ? 5 : 6;

    worksheet.mergeCells(
      `A${column}:${
        isInhouse ? endColumnLetter : isMembership ? "N" : "L"
      }${column}`
    );
    const title = worksheet.getCell(`A${column}`);
    title.value = "MENUS PRICE LIST";
    title.font = { bold: true, size: 20 };
    title.border = border;
    title.alignment = { horizontal: "center" };
  },
  main: ({ worksheet, menus, form }) => {
    const { priceCategories = [], menuType = "", hmo = "" } = form;
    const isInhouse = menuType === "inhouse";
    const isHMO = menuType === "hmo";
    const isMembership = menuType === "mbs";
    worksheet.addRow([]);
    worksheet.addRow([]);

    console.log("priceCategoires", priceCategories);

    let startingRow = isInhouse ? 6 : 7;

    let prevCol = 0;

    const headers = [
      { text: "Name", space: 6 },
      { text: "Services Inclusion", space: 4 },
      ...(isInhouse ? priceCategories : [{ text: "SRP", space: 2 }]),
      ...(isMembership ? [{ text: "UP", space: 2 }] : []),
    ];

    for (const { text, space = 2 } of headers) {
      const headPos = `${getAlpha(prevCol)}${startingRow}`;
      const head = worksheet.getCell(headPos);
      const rowHead = worksheet.getRow(`${startingRow}`);
      rowHead.height = 20;
      head.value = text;
      head.alignment = {
        vertical: "middle",
        wrapText: true,
      };
      head.font = { bold: true, size: 12 };
      head.border = border;
      if (space > 1) {
        worksheet.mergeCells(
          `${headPos}:${getAlpha(prevCol + space - 1)}${startingRow}`
        );
      }

      prevCol += space;
    }

    const handlePrices = (obj) => {
      if (isInhouse) {
        return priceCategories.map(({ value }) => obj?.[value] || 0);
      }
      if (isHMO) {
        return [HMO.getSrp(hmo, obj?.hmo)];
      }
      if (isMembership) {
        const { membership } = form?.insource;
        const { opd = 0 } = obj;
        return [opd, Memberships.getDiscountedSRP(membership, obj)];
      }
      return [obj?.[form?.insource?.contract]];
    };

    processArray(menus, startingRow + 1);

    function processArray(array, startPos) {
      for (let i = 0; i < array?.length; i++) {
        const {
          packages,
          description: name = "",
          abbreviation = "",
        } = array[i] || {};

        const rawServices = Services.whereIn(packages);

        // Build richText with A., B., C. labels in bold
        const servicesRichText = rawServices.flatMap((service, _) => {
          return [
            {
              text: service.abbreviation + ",    ",
              font: { size: 11 },
            },
          ];
        });

        const element = [
          {
            richText: [
              { text: `${i + 1}. `, font: { size: 11 } },
              { text: `${name || abbreviation}`, font: { size: 13 } },
            ],
          },
          { richText: servicesRichText },
          ...handlePrices(array[i]),
        ];

        let _prevCol = 0;
        let maxLength = 0;

        for (let j = 0; j < element.length; j++) {
          const value = element[j];
          const { space = 2 } = headers[j] || {};
          const cellPos = `${getAlpha(_prevCol)}${startPos}`;
          const cell = worksheet.getCell(cellPos);

          cell.font = { size: 13 };

          if (j > 1) {
            cell.numFmt = '"₱"#,##0.00';
          }

          cell.value = value;

          cell.alignment = {
            horizontal: "left",
            vertical: "middle",
            wrapText: true,
          };

          cell.border = border;

          // Only count plain string lengths for height calculation
          const valueLength =
            typeof value === "string"
              ? value.length
              : value?.richText?.map((t) => t.text).join("").length || 0;

          if (valueLength > maxLength) {
            maxLength = valueLength;
          }

          if (space > 1) {
            worksheet.mergeCells(
              `${cellPos}:${getAlpha(_prevCol + space - 1)}${startPos}`
            );
          }

          _prevCol += space;
        }

        // Adjust row height
        const charsPerLine = 32;
        const lines = Math.ceil(maxLength / charsPerLine);
        const baseHeight = 22;
        const lineHeight = 13;

        worksheet.getRow(startPos).height =
          baseHeight + (lines - 1) * lineHeight;

        startPos++;
      }

      return startPos;
    }
  },
  footer: ({ worksheet, skip, createdBy }) => {
    var startPos = skip + 1;
    const year = new Date().getFullYear();

    // Final formatted string (e.g., "June 30, 2025")
    const validUntil = `December 31, ${year}`;
    const infoRows = [
      { label: "Prepared by: ", value: createdBy },
      {
        label: "Issued on: ",
        value: new Date().toLocaleString("en-US", {
          month: "long",
          day: "numeric",
          year: "numeric",
          hour: "numeric",
          minute: "numeric",
          hour12: true, // optional, for AM/PM format
        }),
      },
      {
        label: "Note: ",
        value: `Prices are exclusive of additional services unless stated. Valid until ${validUntil}`,
      },
    ];

    infoRows.forEach((item, idx) => {
      const rowNum = startPos + idx; // rows above Legend
      worksheet.mergeCells(`A${rowNum}:L${rowNum}`);
      const cell = worksheet.getCell(`A${rowNum}`);
      cell.border = border;
      cell.value = {
        richText: [
          { text: item.label, font: { bold: true, size: 13 } },
          { text: item.value, font: { size: 13 } },
        ],
      };
      cell.alignment = { vertical: "middle", horizontal: "left" };
    });
  },
};
// options list

const menuTypes = {
  inhouse: "Inhouse",
  mbs: "Membership",
  ctr: "Contract",
  hmo: "HMO",
};

const excel = async ({ menus = [], form, createdBy }) => {
  if (!menus.length) return;
  const isInhouse = form.menuType === "inhouse";

  const workbook = new ExcelJS.Workbook(),
    worksheet = workbook.addWorksheet("Price List");

  //  Set the showGridLines property to false to hide grid lines
  worksheet.views = [{ showGridLines: false }];

  await set.banner({ worksheet, workbook, form });
  set.header({ worksheet, form });
  set.main({ worksheet, menus, form });

  const skip = menus.length + (isInhouse ? 7 : 8);
  set.footer({ worksheet, skip, createdBy });

  // Save the workbook
  await workbook.xlsx.writeBuffer().then((buffer) => {
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(
      blob,
      `${menuTypes[form.menuType]} Menus Price List ${new Date().toLocaleString(
        "en-US",
        {
          month: "long",
          day: "numeric",
          year: "numeric",
        }
      )}.xlsx`
    );
  });
};

export default excel;
